import axios from 'axios';
import { API_HOST } from '../consts';

const fetchBloodTypeOptions = async (params) => {
  const res = await axios.get(`${API_HOST}/health/blood_type`, { params });
  return res.data;
};

export default fetchBloodTypeOptions;
